module.exports = __webpack_public_path__ + "static/img/icon7-10.02e1d23e.png";